import { MantineColorsTuple } from '@mantine/core';
import { baseColorTokens } from '@datavant/design-tokens';

export const dark = [
    baseColorTokens.coolGray100,
    baseColorTokens.coolGray200,
    baseColorTokens.coolGray300,
    baseColorTokens.coolGray400,
    baseColorTokens.coolGray500,
    baseColorTokens.coolGray600,
    baseColorTokens.coolGray700,
    baseColorTokens.coolGray800,
    baseColorTokens.coolGray900,
    baseColorTokens.coolGray1000,
] satisfies MantineColorsTuple;

export const gray = [
    baseColorTokens.warmGray100,
    baseColorTokens.warmGray200,
    baseColorTokens.warmGray300,
    baseColorTokens.warmGray400,
    baseColorTokens.warmGray500,
    baseColorTokens.warmGray600,
    baseColorTokens.warmGray700,
    baseColorTokens.warmGray800,
    baseColorTokens.warmGray900,
    baseColorTokens.warmGray1000,
] satisfies MantineColorsTuple;

export const red = [
    baseColorTokens.red100,
    baseColorTokens.red200,
    baseColorTokens.red300,
    baseColorTokens.red400,
    baseColorTokens.red500,
    baseColorTokens.red600,
    baseColorTokens.red700,
    baseColorTokens.red800,
    baseColorTokens.red900,
    baseColorTokens.red1000,
] satisfies MantineColorsTuple;

export const pink = [
    baseColorTokens.pink100,
    baseColorTokens.pink200,
    baseColorTokens.pink300,
    baseColorTokens.pink400,
    baseColorTokens.pink500,
    baseColorTokens.pink600,
    baseColorTokens.pink700,
    baseColorTokens.pink800,
    baseColorTokens.pink900,
    baseColorTokens.pink1000,
] satisfies MantineColorsTuple;

export const violet = [
    baseColorTokens.violet100,
    baseColorTokens.violet200,
    baseColorTokens.violet300,
    baseColorTokens.violet400,
    baseColorTokens.violet500,
    baseColorTokens.violet600,
    baseColorTokens.violet700,
    baseColorTokens.violet800,
    baseColorTokens.violet900,
    baseColorTokens.violet1000,
] satisfies MantineColorsTuple;

export const blue = [
    baseColorTokens.blue100,
    baseColorTokens.blue200,
    baseColorTokens.blue300,
    baseColorTokens.blue400,
    baseColorTokens.blue500,
    baseColorTokens.blue600,
    baseColorTokens.blue700,
    baseColorTokens.blue800,
    baseColorTokens.blue900,
    baseColorTokens.blue1000,
] satisfies MantineColorsTuple;

export const cyan = [
    baseColorTokens.cyan100,
    baseColorTokens.cyan200,
    baseColorTokens.cyan300,
    baseColorTokens.cyan400,
    baseColorTokens.cyan500,
    baseColorTokens.cyan600,
    baseColorTokens.cyan700,
    baseColorTokens.cyan800,
    baseColorTokens.cyan900,
    baseColorTokens.cyan1000,
] satisfies MantineColorsTuple;

export const teal = [
    baseColorTokens.seafoam100,
    baseColorTokens.seafoam200,
    baseColorTokens.seafoam300,
    baseColorTokens.seafoam400,
    baseColorTokens.seafoam500,
    baseColorTokens.seafoam600,
    baseColorTokens.seafoam700,
    baseColorTokens.seafoam800,
    baseColorTokens.seafoam900,
    baseColorTokens.seafoam1000,
] satisfies MantineColorsTuple;

export const green = [
    baseColorTokens.green100,
    baseColorTokens.green200,
    baseColorTokens.green300,
    baseColorTokens.green400,
    baseColorTokens.green500,
    baseColorTokens.green600,
    baseColorTokens.green700,
    baseColorTokens.green800,
    baseColorTokens.green900,
    baseColorTokens.green1000,
] satisfies MantineColorsTuple;

export const yellow = [
    baseColorTokens.yellow100,
    baseColorTokens.yellow200,
    baseColorTokens.yellow300,
    baseColorTokens.yellow400,
    baseColorTokens.yellow500,
    baseColorTokens.yellow600,
    baseColorTokens.yellow700,
    baseColorTokens.yellow800,
    baseColorTokens.yellow900,
    baseColorTokens.yellow1000,
] satisfies MantineColorsTuple;

export const orange = [
    baseColorTokens.orange100,
    baseColorTokens.orange200,
    baseColorTokens.orange300,
    baseColorTokens.orange400,
    baseColorTokens.orange500,
    baseColorTokens.orange600,
    baseColorTokens.orange700,
    baseColorTokens.orange800,
    baseColorTokens.orange900,
    baseColorTokens.orange1000,
] satisfies MantineColorsTuple;
